import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/App'
import { tg } from './shared/lib/telegram'

// Telegram ждёт ready(), иначе показывает загрузку поверх приложения.
tg?.ready()
tg?.expand()

const container = document.getElementById('root')
if (!container) throw new Error('В index.html нет узла #root')

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
